import { render, staticRenderFns } from "./BerthCommodityRemoveModal.vue?vue&type=template&id=2e2e4265&scoped=true&"
import script from "./BerthCommodityRemoveModal.vue?vue&type=script&lang=js&"
export * from "./BerthCommodityRemoveModal.vue?vue&type=script&lang=js&"
import style1 from "./BerthCommodityRemoveModal.vue?vue&type=style&index=1&id=2e2e4265&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2e4265",
  null
  
)

export default component.exports